import { render, staticRenderFns } from "./ConstructionScheme.vue?vue&type=template&id=3dba4894"
import script from "./ConstructionScheme.vue?vue&type=script&lang=js"
export * from "./ConstructionScheme.vue?vue&type=script&lang=js"
import style0 from "./ConstructionScheme.vue?vue&type=style&index=0&id=3dba4894&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports